
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/__inspiration-images__/[slug]",
      function () {
        return require("private-next-pages/__inspiration-images__/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/__inspiration-images__/[slug]"])
      });
    }
  